// Research Engine — footer (logged-out landing only).
import { useTranslation } from "react-i18next";
import { Logo } from "./Logo";

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border mt-24">
      <div className="max-w-[1320px] mx-auto px-6 py-10 flex flex-wrap items-end justify-between gap-6">
        <div>
          <Logo size="sm" />
          <div className="text-[12.5px] text-ink-faint mt-2">{t("footer.tagline")}</div>
        </div>
        <div className="flex gap-6 text-[12.5px] text-ink-dim">
          <a href="#" className="hover:text-ink">{t("footer.docs")}</a>
          <a href="#" className="hover:text-ink">{t("footer.changelog")}</a>
          <a href="#" className="hover:text-ink">{t("footer.pricing")}</a>
          <a href="#" className="hover:text-ink">{t("footer.privacy")}</a>
          <a href="#" className="hover:text-ink">{t("footer.terms")}</a>
        </div>
      </div>
    </footer>
  );
}
